export default __webpack_public_path__ + "static/media/27_Mountop.5ed16621.png";